import { css } from 'styled-components';

export const buttonMixin = (props: any) => {
  return css`
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
    -webkit-user-select: none;
    border-color: transparent;
    border-width: 1px;
    border-style: solid;
    border-radius: 3px;
    flex-grow: 0.2;
    flex-basis: 75px;
    text-align: center;
    margin: 2px 4px;
    max-width: ${(props: any) => (props.maxWidth ? props.maxWidth : '256px')};
    min-width: ${(props: any) => (props.minWidth ? props.minWidth : null)};
    cursor: ${(props: any) => (props.disabled ? 'not-allowed ' : 'pointer')};
    opacity: ${(props: any) => (props.disabled ? 0.5 : 1)};
    display: ${(props: any) => (props.inline ? 'inline' : 'block')};
  `;
};

export const colorMixin = (props: any, type: string) => {
  return css`
    color: ${(props) => props.theme.buttons[type].text};
    border-color: ${(props) => props.theme.buttons[type].border};
    background-color: ${(props) => props.theme.buttons[type].background};

    ${(props: any) =>
      !props.disabled &&
      css`
        &:hover,
        &:focus {
          color: ${(props) => props.theme.buttons[type].hoverText};
          border-color: ${(props) => props.theme.buttons[type].hoverBorder};
          background-color: ${(props) => props.theme.buttons[type].hoverBackground};
        }
      `};
  `;
};

export const sizeMixin = ({ small, large }: any) => {
  if (!small && !large) {
    return css`
      padding: ${(props: any) => props.padding || '0px 10px'};
      font-size: 14px;
      font-weight: 500;
    `;
  }
  if (small) {
    return css`
      padding: 3px 10px;
      font-size: 12px;
      font-weight: 500;
    `;
  }
  return css`
    padding: 12px 10px;
    font-size: 15px;
    font-weight: 500;
    margin: 0;
    max-width: 420px;
  `;
};
